import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { getErrorMessage } from 'redux/slices/authentication'
import { useAuth0, LoginAction } from 'libs/web-client/utils/auth0/src'
import useStyles from './styles'

interface SignUpModalProps {
    canClose?: boolean
}

const SignupModal: React.FC<SignUpModalProps> = () => {
    const { loginWithPopup } = useAuth0()
    const errorMessage = useSelector(getErrorMessage)
    const classes = useStyles()

    const handleLinkClick = useCallback(() => loginWithPopup({ action: LoginAction.LOGIN }), [loginWithPopup])
    const handleSubmit = useCallback(() => loginWithPopup({ action: LoginAction.REGISTER }), [loginWithPopup])

    return (
        <div className={classes.root}>
            <div className={classes.logo} />

            {errorMessage && <p className={clsx(classes.message, classes.error)}>{errorMessage}</p>}

            <CallToActionButton
                onClick={handleSubmit}
                text="Sign up for the live experience"
                display="block"
                type="primary"
                className={classes.signupBtn}
                id="sign-up-submit-btn"
            />

            <div onClick={handleLinkClick} className={classes.subtitle}>
                Already have an account?
            </div>
        </div>
    )
}

export default React.memo(SignupModal)
